"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Constants = require("./constants");
const lib_es2015_1 = require("@hodol/webapp-common/lib-es2015");
class SpectrumApis {
    constructor() {
        this.getHypotheticalSpectra = (maxWindowSize) => __awaiter(this, void 0, void 0, function* () {
            return yield (0, lib_es2015_1.fetchWrapper)(`/apis/${Constants.apiPathGroup}/hypothetical/max-window/${maxWindowSize}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                },
            }, (lib_es2015_1.defaultCodeProcessor));
        });
        this.getSpectraFacet = (number, windowSize) => __awaiter(this, void 0, void 0, function* () {
            return yield (0, lib_es2015_1.fetchWrapper)(`/apis/${Constants.apiPathGroup}/facet/number/${number}/window/${windowSize}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                },
            }, (lib_es2015_1.defaultCodeProcessor));
        });
        // insertMemo = async (entity: Pick<Entity, 'title' | 'content' | 'style_set' | 'is_private'>): Promise<number | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}`, {
        //     method: 'POST',
        //     headers: {
        //       'Content-type': 'application/json',
        //     },
        //     body: JSON.stringify(entity),
        //   },
        //     defaultCodeProcessor<number>,
        //   );
        // };
        //
        // listMemos = async (isPrivate: boolean): Promise<ListPage<Entity> | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}?is_private=${isPrivate ? 'true' : 'false'}`, {
        //     method: 'GET',
        //   },
        //     defaultCodeProcessor<ListPage<Entity>>,
        //   );
        // };
        //
        // getMemoByPK = async (entity: Pick<Entity, 'pk'>): Promise<Entity | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}/pk/${entity.pk}`, {
        //     method: 'GET',
        //   },
        //     defaultCodeProcessor<Entity>,
        //   );
        // };
        //
        // updateMemo = async (pk: number, entity: Pick<Entity, 'title' | 'content' | 'style_set' | 'is_private'>): Promise<string | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}/pk/${pk}`, {
        //     method: 'PATCH',
        //     headers: {
        //       'Content-type': 'application/json',
        //     },
        //     body: JSON.stringify(entity),
        //   },
        //     defaultCodeProcessor<string>,
        //   );
        // };
        //
        // updateMemoStyles = async (entityList: Array<Pick<Entity, 'pk' | 'style_set'>>): Promise<string | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}/styles`, {
        //     method: 'PATCH',
        //     headers: {
        //       'Content-type': 'application/json',
        //     },
        //     body: JSON.stringify(entityList),
        //   },
        //     defaultCodeProcessor<string>,
        //   );
        // };
        //
        // deleteMemo = async (entity: Pick<Entity, 'pk'>): Promise<string | null> => {
        //   return await fetchWrapper(`/apis/${Constants.apiPathGroup}/pk/${entity.pk}`, {
        //     method: 'DELETE',
        //   },
        //     defaultCodeProcessor<string>,
        //   );
        // };
    }
}
exports.default = SpectrumApis;
